import Constants from '../actions/types';

const initialState = {
  users: [],
  loading: false,
  newUser: null,
  message: null,
  severity: null
};

const removePermissions = user => {
  delete user.permissions;
  return user;
};

const usersReducer = (state = initialState, action) => {
  // console.log(
  //   'In usersReducer with state ' +
  //     JSON.stringify(state) +
  //     ' and action ' +
  //     JSON.stringify(action)
  // );
  switch (action.type) {
    case Constants.USERS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.USERS_GET_SUCCESS: {
      const newState = {
        ...state,
        users: action.payload.map(u => removePermissions(u)),
        loading: false
      };

      return newState;
    }

    case Constants.USERS_GET_FAILURE: {
      const newState = {
        ...state,
        users: [],
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.USERS_ADD_SUCCESS: {
      const newUsers = [...state.users, removePermissions(action.payload)];
      const newState = {
        ...state,
        newUser: null,
        users: newUsers,
        loading: false,
        message: 'The user was added successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.USERS_DELETE_SUCCESS: {
      const selectedUser = state.users.find(
        user => user.id === action.payload.id
      );
      const index = state.users.indexOf(selectedUser);
      const newUsers = [].concat(
        state.users.slice(0, index),
        state.users.slice(index + 1)
      );
      const newState = {
        ...state,
        users: newUsers,
        loading: false,
        message: 'The user was deleted successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.USERS_DELETE_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.USERS_SAVE_SUCCESS: {
      const found = state.users.find(u => u.id === action.payload.id);
      const index = state.users.indexOf(found);
      const newUsers = [
        ...state.users.slice(0, index),
        action.payload,
        ...state.users.slice(index + 1)
      ];

      const newState = {
        ...state,
        newUser: null,
        users: newUsers,
        loading: false,
        message: 'The user was saved successfully.',
        severity: 'info'
      };

      return newState;
    }

    // This is treated almost like an update since we update the data
    // of one specific account when it is reloaded from the server
    case Constants.USER_GET_SUCCESS: {
      const found = state.users.find(u => u.id === action.payload.id);
      const index = state.users.indexOf(found);
      const newUsers = [
        ...state.users.slice(0, index),
        action.payload,
        ...state.users.slice(index + 1)
      ];

      const newState = {
        ...state,
        newUser: null,
        users: newUsers,
        loading: false,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.USER_GET_FAILURE: {
      const newState = {
        ...state,
        users: [],
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.USERS_SAVE_LOCAL_SUCCESS: {
      const newState = {
        ...state,
        newUser: action.payload
      };

      return newState;
    }

    case Constants.USERS_SAVE_FAILURE: {
      const newState = {
        ...state,
        newUser: action.payload.user,
        loading: false,
        message: action.payload.message,
        severity: 'error'
      };

      return newState;
    }

    case Constants.USERS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default usersReducer;
